module.exports = __webpack_public_path__ + "img/21.ea63f699.svg";